export default {"src":"/_next/static/media/golden-lake-logo.69497412.svg","height":89,"width":116,"blurWidth":0,"blurHeight":0};